import { store } from "@redux"
import thousandSeparator from "./thousandSeparator"
import formatMobilePhone from "./formatMobilePhone"
import englishToFarsiDigitConverter from "./englishToFarsiDigitConverter"
import calculateItemSalePrice from "./calculateItemSalePrice"

const getWhatsappLinkPayMessage = (order, paymentId) => {
  const { domain, subdomain, customDomainName } =
    store.getState().systemSettings

  let message = "اطلاعات سفارش"

  message += "\n\n"

  message += `شماره سفارش: ${order.code}`

  message += "\n\n"

  message += `نام و نام خانوادگی: ${order.address?.recipientName || order.customerFullName}`

  message += "\n"

  if (order.deliveryType === "delivery") {
    message += `آدرس: ${order.address.address}`

    message += "\n"

    if (!!order.address.zipCode) {
      message += `کد پستی: ${order.address.zipCode}`

      message += "\n"
    }
  }

  const mobilePhone =
    formatMobilePhone(
      order.address?.recipientPhoneNumber ||
      order.customerMobilePhone
    )

  message += `شماره تماس: ${mobilePhone}`

  message += "\n"

  message += `اقلام سفارش:`

  message += "\n"

  order.items.forEach((item, itemIndex) => {
    let itemMessage = ""

    itemMessage += `${itemIndex + 1}- ${item.foodName}`

    itemMessage += item.isSimple ? "" : `, ${item.option.name}`

    !!item.specificationItems &&
      item.specificationItems.forEach((specificationItem) => {
        itemMessage += `, ${specificationItem.name}`
      })

    itemMessage += "\n"

    itemMessage =
      englishToFarsiDigitConverter(itemMessage)

    message += itemMessage
  })

  message += "\n"

  const discount =
    order.foodDiscount +
    order.deliveryDiscount +
    order.systemDiscount

  const subtotal =
    order.items.reduce((t, item) =>
      t += calculateItemSalePrice(item) * item.quantity
      , 0
    )

  let summary = ""

  summary += `جمع مبلغ سفارش: ${thousandSeparator(subtotal)}`

  summary += "\n"

  if (order.deliveryFee > 0) {
    summary += `هزینه ی حمل و نقل: ${thousandSeparator(order.deliveryFee)}`

    summary += "\n"
  }

  if (discount > 0) {
    summary += `تخفیف: ${thousandSeparator(discount)}`

    summary += "\n"
  }

  summary += `کل مبلغ قابل پرداخت: ${thousandSeparator(order.totalBillAmount)}`

  summary =
    englishToFarsiDigitConverter(summary)

  message += summary

  message += "\n\n"

  message += `لینک پرداخت:`

  message += "\n"

  const websiteBaseUrl =
    !!customDomainName
      ? `https://${customDomainName}`
      : `https://${subdomain}.${domain}`

  const linkpay =
    process.env.NODE_ENV === "production"
      ? `https://${websiteBaseUrl}/link/${paymentId}`
      : `http://${subdomain}.localhost:8094/link/${paymentId}`

  message += linkpay

  message += "\n\n"

  message += "ممنون از خرید شما"

  return message
}

export default getWhatsappLinkPayMessage